import { alpha } from '@mui/material';

const lightPalette = {
  type: 'light',
  background: {
    default: '#F7F7FE',
  },
  text: {
    primary: '#222222',
    secondary: '#222222',
  },
  primary: {
    contrastText: '#FFFFFF',
    dark: '#586CC2',
    light: '#8598EE',
    main: '#667EEA',
  },
  secondary: {
    contrastText: '#FFFFFF',
    dark: '#7956C2',
    light: '#A582EE',
    main: '#8F63EA',
  },
  success: {
    contrastText: '#FFFFFF',
    dark: '#1F8B4D',
    light: '#52BE80',
    main: '#27AE60',
  },
  warning: {
    contrastText: '#FFFFFF',
    dark: '#C27A3B',
    light: '#F5AD6E',
    main: '#F2994A',
  },
  error: {
    contrastText: '#FFFFFF',
    dark: '#BC4646',
    light: '#EF7979',
    main: '#EB5757',
  },
  gradient: {
    main: 'linear-gradient(90deg, #667EEA 0%, #764BA2 100%);',
    contrastText: '#FFFFFF',
  },
  a11y: {
    light: 'transparent',
    main: '#FFFFFF',
    dark: '#222222',
    contrastText: 'transparent',
  },
  grey: {
    50: alpha('#222222', 0.05),
    100: alpha('#222222', 0.1),
    200: alpha('#222222', 0.2),
    300: alpha('#222222', 0.3),
    400: alpha('#222222', 0.4),
    500: alpha('#222222', 0.5),
    600: alpha('#222222', 0.6),
    700: alpha('#222222', 0.7),
    800: alpha('#222222', 0.8),
    900: alpha('#222222', 0.9),
  },
  light: {
    50: alpha('#FFFFFF', 0.05),
    100: alpha('#FFFFFF', 0.1),
    200: alpha('#FFFFFF', 0.2),
    300: alpha('#FFFFFF', 0.3),
    400: alpha('#FFFFFF', 0.4),
    500: alpha('#FFFFFF', 0.5),
    600: alpha('#FFFFFF', 0.6),
    700: alpha('#FFFFFF', 0.7),
    800: alpha('#FFFFFF', 0.8),
    900: alpha('#FFFFFF', 0.9),
  },
};

export default lightPalette;
